<div
  class="h-full w-full absolute inset-0 {($configuration['bg-color'] || story.color) && 'overlay'} {$configuration['bg-blur-dark'] ? 'overlay-dark' : ''}"
  style="--bg-color: {$configuration['bg-color'] || story.color}">
  {#if $configuration['bg-blur'] || $configuration['bg-blur-dark']}
    <img src="{get(story, 'poster.blur.dataUrl')}" alt="" />
  {/if}
</div>

<script>
  import { get } from 'lodash-es'
  import { configuration } from '~/store/index.js'

  export let story
</script>

<style>
  .overlay {
    background-color: var(--bg-color);
  }
  /*.overlay-dark {*/
  /*  position: relative;*/
  /*  display: inline-block;*/
  /*}*/
  img {
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .img-gradient img {
    display: block;
  }
</style>
